import React, {Component, Suspense} from "react";
import {Route, Switch} from "react-router-dom";

// Redux imports to centralize main state
import {Provider} from "react-redux";
import {createBrowserHistory} from 'history';
import {ConnectedRouter} from 'connected-react-router';
import {configStore} from "./redux/configure_store";
import {PersistGate} from 'redux-persist/integration/react';
import HomePageContainer from "./redux/containers/home_page/home_page_container";
import LuissNavbarContainer from "./redux/containers/luiss_navbar/luiss_navbar_container";
import './App.scss';
import CookieBanner from "./common_components/cookie_banner/cookie_banner";

const PageDispatcherContainer = React.lazy(() => import("./redux/containers/page_dispatcher/page_dispatcher_container"));

const history = createBrowserHistory();
const [store, persistor] = configStore(history);

class App extends Component {
    render() {
        return (
            <div>
                <Provider store={store}>
                    <PersistGate loading={null} persistor={persistor}>
                        <ConnectedRouter history={history}>
                            <Suspense fallback={<div>Loading...</div>}>
                                <LuissNavbarContainer/>
                                <Switch>
                                    {/* <Route path="/" exact render={props => <HomePageContainer {...props}/>}/> */}
                                    <Route path="/*" exact render={props => <PageDispatcherContainer {...props} />}/>
                                </Switch>
                            </Suspense>
                        </ConnectedRouter>
                    </PersistGate>
                </Provider>
                {/* Cookie Policy */}
                <CookieBanner/>
            </div>
        );
    }
}

export default App;
